import { fields } from '@synergy/utils';

import { InvoiceItem } from '../../models/invoice-item';
import { Supplier } from '../../../../common/models/supplier';

export interface PositionsFormValues {
    netShippingCosts: number;
    netSurcharge: number;
    isTaxFree: boolean;
    allItems: InvoiceItem[];
    supplier: Supplier | null;
}

export const positionFieldNames = fields<PositionsFormValues>();

export const invoiceItemFieldNames = fields<InvoiceItem>();
